export default {"src":"/_next/static/media/broccolirabe.04bbcaf5.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};